import locales from '../locales.json'

const { regionMap, defaultLocale } = locales

export { defaultLocale, regionMap }

export const parseLocale = (
  locale: string | undefined
): { region: GLOBALS.Region; lang: GLOBALS.Language } => {
  if (locale === undefined || locale === defaultLocale) {
    return { region: 'CZ', lang: 'en' }
  }

  if (!locale.includes('-')) {
    throw new Error('Invalid locale')
  }

  const lang = (locale.split('-')[0] ?? 'en') as GLOBALS.Language
  const region = (locale.split('-')[1] ?? 'CZ') as GLOBALS.Region

  return { region, lang }
}
